export default function Search(opts){
    let container = opts.container
    let search_container_element,search_element,search_confirm_button
    
    // gera todo o componente de pesquisa
    this.generate = () =>{
        generateContainer()
        generateInput()
        eventsHandler()
        search_container_element.appendChild(search_element)
        $(container).html(search_container_element)
    }
    // retorna o texto atual da caixa de pesquisa
    this.getCurrentText = () =>{
        return search_element.value
    }

    function generateContainer(){
        let element = document.createElement("div")
        element.classList.add("offcanvas-stations-search-wrapper")
        search_container_element = element
    }

    function generateInput(){
        let element = document.createElement("input")
        element.classList.add("form-control")
        element.placeholder = "Buscar por prefixo/nome"
        search_element = element
    }

    function eventsHandler(){
        $(search_element).on('keyup', function(e){
            $(container).trigger("input:change", {value: e.target.value})
        })
    }
}